import { render, staticRenderFns } from "./DarkProductCard.vue?vue&type=template&id=02b6dee4&scoped=true"
import script from "./DarkProductCard.vue?vue&type=script&lang=js"
export * from "./DarkProductCard.vue?vue&type=script&lang=js"
import style0 from "./DarkProductCard.vue?vue&type=style&index=0&id=02b6dee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6dee4",
  null
  
)

export default component.exports